import AppServiceNewApi from "./AppServiceNewApi";

class CompanyServiceNewApi extends AppServiceNewApi {
  constructor() {
    super();
    this.path = "/api/internal/v1/companies";
  }

  getChildsByCompany(companyId){
    return this.http.get(`${this.path}/child/${companyId}`)
  }

  getCompanies(pagination, organizationId, filters, sort ) { 
    let filterString = "&";
    if (filters?.name) filterString = `${filterString}Name=${filters?.name}&`;
    if (filters?.status)filterString = `${filterString}Status=${filters?.status}&`;
    if (sort?.order)filterString = `${filterString}OrderByName=${sort?.order}&`;
    if (sort?.order && sort?.direction)filterString = `${filterString}AscOrDesc=${sort?.direction}&`;
    if (filterString === "&") filterString = "";
    else filterString = filterString.substring(0, filterString?.length - 1);
    const URL = `${this.path}?organizationId=${organizationId}&PageNumber=${pagination?.page}&PageSize=${pagination?.size}${filterString}`;
    return this.http.get(`${URL}`);
  }

  getCompanyById(id) {
    const URL = `${this.path}/${id}`;
    return this.http.get(`${URL}`);
  }

  addCompany(body, organizationId) {
    const headers = {'organizationId':organizationId}
    const URL = `${this.path}`;
    return this.http.post(`${URL}`, body, {headers});
  }

  updateCompany(body, id) {
    const URL = `${this.path}/${id}`;
    return this.http.put(`${URL}`, body);
  }
  
  updateCompanyStatus(companyId, status) {
    const URL = `${this.path}/update-status/${companyId}?status=${status}`;
    return this.http.put(`${URL}`, {});
  }

  getLogo(id) {
    return this.http.get(`${this.path}/${id}/logo`);
  }

  changeLogoToCompany(image, id) {
    const URL = `${this.path}/${id}`;
    return this.http.post(URL, image);
  }

  resendQuestionnaire(id) {
    return this.http.post(
      `${this.path}/${id}/resend-questionnaire-link-employess`
    );
  }

  me() {
    return this.http.get(`/auth/v1/auth/me`);
  }

  codeGenerateLink(companyId) {
		return this.http.get(`${this.path}/${companyId}/qr-code-link`);
	}

  validateWebhookInformation(body) {
    return this.http.post(`${this.path}/verify-connect-webhook`, body);
  }

  addEmployerByFile(file, organizationId){
    return this.http.post(`${this.path}/batch-create-companies?organizationId=${organizationId}`, file)
  }
  
  updateEmployerByFile(file){
    return this.http.put(`${this.path}/update-from-file`, file)
  }
  
  getTempleteForAddEmployers(){
    return this.http.get(`${this.path}/download-company-csv-template`)
  }
  
  getTempleteForUpdateEmployers(){
    return this.http.get(`${this.path}/download-update-company-csv`)
  }
  
}
export default CompanyServiceNewApi;
